var map = {
	"./apple.svg": 7854,
	"./arrow.svg": 1449,
	"./blockquote.svg": 7343,
	"./calender-icon.svg": 4934,
	"./close.svg": 862,
	"./crown.svg": 8243,
	"./edit.svg": 7654,
	"./facebook.svg": 3254,
	"./follow-facebook.svg": 5338,
	"./follow-instagram.svg": 5566,
	"./follow-x.svg": 6530,
	"./follow-youtube.svg": 8301,
	"./gears.svg": 6594,
	"./google.svg": 4087,
	"./grid.svg": 8666,
	"./hamburger.svg": 795,
	"./highlights.svg": 6345,
	"./image-icon.svg": 285,
	"./image.svg": 1113,
	"./left-arrow.svg": 7445,
	"./linkedin.svg": 3380,
	"./list.svg": 5742,
	"./loading.svg": 9702,
	"./login.svg": 5089,
	"./logo.svg": 9155,
	"./phone.svg": 9746,
	"./play-solid.svg": 9910,
	"./profile.svg": 8425,
	"./read-more-arrow.svg": 3992,
	"./right-arrow-two.svg": 9365,
	"./right-arrow.svg": 5208,
	"./search.svg": 4626,
	"./share.svg": 6711,
	"./simple-arrow.svg": 4616,
	"./solid-arrow-down.svg": 5708,
	"./story-play.svg": 7780,
	"./success-circle.svg": 1352,
	"./summary.svg": 2526,
	"./user-icon.svg": 4487,
	"./user.svg": 8595,
	"./visual-story.svg": 7166,
	"./web-story.svg": 1860
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1139;